exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.main[data-v-7e343b60]{\n    padding: .24rem;\n    padding-top: .98rem;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    min-height: 100vh;\n    background: #fff;\n}\n.title[data-v-7e343b60]{\n    font-size: .36rem;\n    font-weight: bold;\n    color: #000;\n    margin: .32rem 0 .2rem;\n}\n.time[data-v-7e343b60]{\n    font-size: .26rem;\n    color: #737373;\n    margin-bottom: .34rem;\n}\n.content[data-v-7e343b60]{\n    font-size: .3rem;\n    color: #000;\n    white-space: pre-wrap;\n    line-height: .42rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e343b60","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/activityDetail.vue
// module id = OSWX
// module chunks = 1